import { createSlice } from '@reduxjs/toolkit';

export const localServiceSlice = createSlice({
    name: 'localService',
    initialState: null,
    reducers: {
        setLocalData: (state, { payload } ) => {
            return { ...payload };
        },
    }
});


// Action creators are generated for each case reducer function
export const { setLocalData } = localServiceSlice.actions;
